<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container style="margin-top: 60px">
    <v-dialog
      v-model="dialog"
      max-width="500"
    >
      <v-card>
 <v-card-title class="headline font-weight-light textgrey">Eigene PDF Dateien hochladen
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false"><v-icon color="grey">clear</v-icon></v-btn>
        </v-card-title>
        <v-layout justify-center class="borderStyleUpload ma-4 upluadimg">
          <v-container>
            <v-flex xs12 class="file">
              <v-layout row justify-center>
                <v-flex xs6 class="justify-center">
                  <v-img src="static/Titel_Surfandscan_Upload_Icon.png" height="250" width="250">
                  </v-img>
                </v-flex>
              </v-layout>
              <v-layout row>
                <label class="file-label">
                  <input class="file-input" type="file" name="resume">
                  <span class="file-cta">
            <v-card-text class="file-label mr-5">
              Ganz einfach hier Ihre PDF-Datei hinziehen und fertig
            </v-card-text>
                  </span>
                </label>
              </v-layout>
            </v-flex>
          </v-container>
        </v-layout>
        <v-card-text class="text-left">
          <span class="font-weight-bold textgrey body-2 ">Tipp:</span> <br>
          Sie können immer PDF-Dateien hochladen,<br> wenn Sie die PDF-Datei in <span style="color: #6f6f6e;font-weight: 400">surf</span><span
          style="color: #6f6f6e;font-weight: bolder">and</span><span
          style="color: #6f6f6e;font-weight: 400">scan</span> ziehen.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="grey"
            class="text-none"
            flat="flat"
            @click="dialog = false"
          >
            Abbrechen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DialogWorkOnFiles ref="dlgWorkOnFiles" @onSave="doWorkOnFiles"></DialogWorkOnFiles>
    <DialogStatus ref="dlgStatus"></DialogStatus>
    <MainToolbar></MainToolbar>
    <v-container class="py-0 finden">
      <v-layout row wrap class="hidden-sm-and-down">
        <v-flex xs12 md6 class="pa-2">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Suche"
            @change="doSearch()"
            single-line
            clearable
            solo
            color="#6f6f6e"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 class="pa-2">
          <v-layout row wrap>
            <v-flex xs4 class="px-2">
              <v-layout row wrap>
                <v-flex xs6>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        flat
                        @click="showFilter = !showFilter"
                        color="transparent"
                        v-on="on"
                      ><v-icon large color="#6274af">filter_list</v-icon></v-btn>
                    </template>
                    <span>Weitere Suchkriterien einblenden / ausblenden</span>
                  </v-tooltip>

                </v-flex>
                <v-flex xs6>
                  <v-menu offset-y v-model="myMenuFilter1">
                    <template v-slot:activator="{ on1 }">
                      <v-btn
                        flat
                        icon
                        color="transparent"
                        @mouseover="myMenuFilter1=true"
                        v-on="on1"
                      >
                        <v-icon large color="#6274af">date_range <!-- filter_list --></v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-list>
                        <v-list-tile v-for="(df, i) in dateFilters" v-bind:key="i">
                          <v-list-tile-content>
                            <!--<v-btn @click="changeDateFilter(df)">{{df.text}}</v-btn>-->
                            <v-list-tile-title class="handpointer" @click="changeDateFilter(df)">{{ df.text }}
                            </v-list-tile-title>
                            <!--<v-list-tile-sub-title class="textblue">Mehrere Seiten</v-list-tile-sub-title>-->
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                      <!--<v-select v-model="dateFilter" :items="dateFilters" @change="changeDateFilter"></v-select>-->
                    </v-card>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6>
              <v-layout row wrap>
                <v-flex xs6 class="px-2">
                  <v-menu
                    v-model="menu11"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    locale="de-DE"
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dateFrom"
                        label="von"
                        @click:clear="doClearFROM"
                        readonly
                        solo
                        color="#6f6f6e"
                        class="my-input"
                        clearable
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker width="400" class="datebackground" color="#6274af" no-title scrollable v-model="dateFromPS" locale="de-DE" @input="menu11 = false" @change="onChangeFrom"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6 class="px-2">
                  <v-menu
                    v-model="menu22"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    locale="de-DE"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dateTo"
                        label="bis"
                        @click:clear="doClearTO()"
                        clearable
                        solo
                        color="#6f6f6e"
                        class="my-input"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker width="400" class="datebackground" color="#6274af" no-title scrollable v-model="dateToPS" locale="de-DE" @input="menu22 = false" @change="onChangeTo"></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs2 class="pr-2">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    flat
                    icon
                    v-on="on"
                    @click="showAddSection = !showAddSection"
                  ><v-icon large color="#6274af">add</v-icon></v-btn>
                </template>
                <span>Dokumente hinzufügen</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="hidden-sm-and-down" v-if="showFilter">
        <v-flex xs6 class="pa-2">
          <v-combobox
            :items="categories"
            item-text="title"
            v-model="selectedCategories"
            return-object
            @change="onChangeCategory"
            chips
            close
            solo
            color="#6f6f6e"
            multiple
            label="Kategorie"
          >
            <template v-slot:selection="data">
              <v-chip
                :selected="data.selected"
                close
                @input="removeCategory(data.item)"
              >
                <strong>{{data.item.title}}</strong>
              </v-chip>
            </template>
          </v-combobox>
        </v-flex>
        <v-flex xs6 class="pa-2">
          <v-combobox
            v-model="currentStatus"
            :items="statusList"
            label="Status"
            item-text="title"
            return-object
            solo
            multiple
            close
            chips
            @change="onChangeStatus"
            clearable
          >
            <template v-slot:selection="data">
              <v-chip
                :selected="data.selected"
                close
                @input="removeStatus(data.item)"
              >
                <strong>{{data.item.title}}</strong>
              </v-chip>
            </template>
          </v-combobox>
        </v-flex>
      </v-layout>
      <v-expansion-panel v-model="panel" class="hidden-sm-and-down" v-if="false">
        <v-expansion-panel-content>
          <template v-slot:header>
            <v-flex xs12 sm12 md6 class="py-2">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Suche"
              @change="doSearch()"
              single-line
              clearable
              solo
              color="#6f6f6e"
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md6 class="py-2">
              <v-layout row wrap class="">
                <v-flex xs2>
                  <v-menu right offset-y v-model="myMenuFilter1">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        flat
                        color="transparent"
                        @mouseover="myMenuFilter1=true"
                        v-on="on"
                      >
                        <v-icon large color="#6274af">
                          filter_list
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-list>
                        <v-list-tile v-for="(df, i) in dateFilters" v-bind:key="i">
                          <v-list-tile-content>
                            <!--<v-btn @click="changeDateFilter(df)">{{df.text}}</v-btn>-->
                            <v-list-tile-title class="handpointer" @click="changeDateFilter(df)">{{df.text}}</v-list-tile-title>
                            <!--<v-list-tile-sub-title class="textblue">Mehrere Seiten</v-list-tile-sub-title>-->
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                      <!--<v-select v-model="dateFilter" :items="dateFilters" @change="changeDateFilter"></v-select>-->
                    </v-card>
                  </v-menu>
                </v-flex>
                <v-flex xs4 class="px-2">
                  <v-menu
                    v-model="menu11"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    locale="de-DE"
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="400px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dateFrom"
                        label="von"
                        @click:clear="doClearFROM"
                        readonly
                        solo
                        color="#6f6f6e"
                        class="my-input"
                        clearable
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker width="400" class="datebackground" color="#6274af" no-title scrollable v-model="dateFromPS" locale="de-DE" @input="menu11 = false" @change="onChangeFrom"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs4 class="px-2">
                  <v-menu
                    v-model="menu22"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    locale="de-DE"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dateTo"
                        label="bis"
                        @click:clear="doClearTO()"
                        clearable
                        solo
                        color="#6f6f6e"
                        class="my-input"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker width="400" class="datebackground" color="#6274af" no-title scrollable v-model="dateToPS" locale="de-DE" @input="menu22 = false" @change="onChangeTo"></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-flex>
          </template>
          <v-card color="transparent">
            <v-card-text class="pl-4 pb-0 pt-0">
              <v-layout row wrap>
                <v-flex xs6>
                <v-combobox
                  :items="categories"
                  item-text="title"
                  v-model="selectedCategories"
                  return-object
                  @change="onChangeCategory"
                  class="px-3"
                  chips
                  close
                  attach
                  solo
                  color="#6f6f6e"
                  multiple
                  label="Kategorie"
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :selected="data.selected"
                      close
                      @input="removeCategory(data.item)"
                    >
                      <strong>{{data.item.title}}</strong>
                    </v-chip>
                  </template>
                </v-combobox>
                </v-flex>
                <v-flex xs6>
                <v-combobox
                  v-model="currentStatus"
                  :items="statusList"
                  label="Status"
                  item-text="title"
                  return-object
                  class="px-3 pr-5"
                  solo
                  multiple
                  close
                  chips
                  @change="onChangeStatus"
                  clearable
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :selected="data.selected"
                      close
                      @input="removeStatus(data.item)"
                    >
                      <strong>{{data.item.title}}</strong>
                    </v-chip>
                  </template>
                </v-combobox>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-layout row wrap class="hidden-md-and-up">
        <div class="myFixed">
          <v-btn
            fab
            @click="doAdd"
            color="#6274af"
          ><v-icon large color="white">add</v-icon></v-btn>
        </div>
        <v-flex xs12 sm12 class="pa-2">
          <v-layout>
            <v-flex xs11>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Suche"
                @change="doSearch()"
                single-line
                clearable
                solo
                color="#6f6f6e"
              ></v-text-field>
            </v-flex>
            <v-flex xs1>
              <v-btn
                icon
                flat
                @click="showFilter = !showFilter"
                color="transparent"
                v-on="on"
              ><v-icon large color="#6274af">filter_list</v-icon></v-btn>
            </v-flex>
          </v-layout>

        </v-flex>
        <v-flex xs12 class="pa-2">
          <v-layout row wrap>
            <v-flex xs2>
              <v-menu right offset-y v-model="myMenuFilter">
                <template v-slot:activator="{ on }">
                  <v-btn
                    flat
                    icon
                    color="transparent"
                    @mouseover="myMenuFilter=true"
                    v-on="on"
                  ><v-icon large color="#6274af">date_range</v-icon></v-btn>
                </template>
                <v-card>
                  <v-list>
                    <v-list-tile v-for="(df, i) in dateFilters" v-bind:key="i">
                      <v-list-tile-content>
                        <!--<v-btn @click="changeDateFilter(df)">{{df.text}}</v-btn>-->
                        <v-list-tile-title class="handpointer" @click="changeDateFilter(df)">{{df.text}}</v-list-tile-title>
                        <!--<v-list-tile-sub-title class="textblue">Mehrere Seiten</v-list-tile-sub-title>-->
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                  <!--<v-select v-model="dateFilter" :items="dateFilters" @change="changeDateFilter"></v-select>-->
                </v-card>
              </v-menu>
            </v-flex>
            <v-flex xs5 class="px-2">
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                locale="de-DE"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateFrom"
                    label="von"
                    @click:clear="doClearFROM"
                    readonly
                    solo
                    color="#6f6f6e"
                    class="my-input"
                    clearable
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker width="400" class="datebackground" color="#6274af" no-title scrollable v-model="dateFromPS" locale="de-DE" @input="menu1 = false" @change="onChangeFrom"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs5 class="px-2 pr-3">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                locale="de-DE"
                full-width
                min-width="400px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateTo"
                    label="bis"
                    @click:clear="doClearTO()"
                    clearable
                    solo
                    color="#6f6f6e"
                    class="my-input"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker width="400" class="datebackground" color="#6274af" no-title scrollable v-model="dateToPS" locale="de-DE" @input="menu2 = false" @change="onChangeTo"></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm6 class="pa-2" v-if="showFilter">
    <v-combobox
      :items="categories"
      item-text="title"
      v-model="selectedCategories"
      return-object
      @change="onChangeCategory"
      class=""
      chips
      close
      solo
      color="#6f6f6e"
      multiple
      label="Kategorie"
    >
      <template v-slot:selection="data">
        <v-chip
          :selected="data.selected"
          close
          @input="removeCategory(data.item)"
        >
          <strong>{{data.item.title}}</strong>
        </v-chip>
      </template>
    </v-combobox>
        </v-flex>
        <v-flex xs12 sm6 class="pa-2" v-if="showFilter">
    <v-combobox
      v-model="currentStatus"
      :items="statusList"
      label="Status"
      item-text="title"
      return-object
      class=""
      solo
      multiple
      close
      chips
      @change="onChangeStatus"
      clearable
    >
      <template v-slot:selection="data">
        <v-chip
          :selected="data.selected"
          close
          @input="removeStatus(data.item)"
        >
          <strong>{{data.item.title}}</strong>
        </v-chip>
      </template>
    </v-combobox>
        </v-flex>
      </v-layout>
     <v-layout row wrap class="px-2 hidden-sm-and-down" v-if="showAddSection">
        <v-flex xs12 sm6 md-5 class="pa-2">
          <v-btn block @click="startScan" small outline class="text-none btnwoohoo">hinzufügen Scan </v-btn>
        </v-flex>
              <v-flex xs12 sm6 md-5 class="pa-2">
        <v-btn block @click="startUpload" small outline class="text-none btnwoohoo"> hinzufügen hochladen</v-btn>
      </v-flex>
      <!--<v-card-text class="display-2 textgrey pt-0 text-left">deine daten</v-card-text>-->
      </v-layout>
    </v-container>
    <v-layout row id="multipleButtons" v-if="selected && selected.length > 0">
      <v-flex>
        <v-btn outline color="#6f6f6f" class="title text-none" @click="workOnFiles(selected, 'delete')">löschen</v-btn>
      </v-flex>
      <v-flex>
        <v-btn outline color="#6f6f6f" class="title text-none" @click="workOnFiles(selected, 'status')">status setzen</v-btn>
      </v-flex>
      <v-flex>
        <v-btn outline color="#6f6f6f" class="title text-none" @click="workOnFiles(selected, 'category')">Kategorie setzen</v-btn>
      </v-flex>
      <v-flex>
        <v-btn outline color="#6f6f6f" class="title text-none" @click="workOnFiles(selected, 'mail')">mail senden</v-btn>
      </v-flex>
    </v-layout>
    <v-container class="">
      <v-tabs
        v-model="active"
        ref="myTabs"
        color="rgba(255, 255, 255, 0.5)"
        @change="updateTab"
        slider-color="#6274af"
      >
        <v-tab
          key="Tab1"
          ref="tab1"
          class="text-none"
        >
          Gefundene Dokumente
        </v-tab>
        <v-tab
          key="Tab2"
          ref="tab2"
          dark
          class="text-none"
        >
          Auswertung
        </v-tab>
        <v-tab-item
          key="Tab1"
        >
          <v-card
            flat
            class="pa-3"
          >
            <v-layout row wrap justify-space-around v-resize="onResize">

              <v-flex md12 :key="tableKey">
                <v-alert :value="true" color="#dadada" icon="warning"
                         v-if="(searchResult === null || searchResult.length === 0)">
                <span style="color:black">
                Die Suche nach '{{search}}' ergab keine Treffer
                </span>
                </v-alert>
                <v-data-table
                  :headers="headers"
                  :items="searchResult"
                  height="200"
                  v-model="selected"
                  :total-items="totalItems"
                  select-all
                  item-key="guid"
                  :loading="isLoading"
                  :pagination.sync="pageSync"
                  class="colorrows mytable"
                  :hide-headers="isMobile" :class="{mobile: isMobile}"
                >
                  <template v-slot:headers="props">
                    <tr v-if="!isMobile">
                      <td>
                        <img v-if="props.all" :src="hicon2" height="32" @click.stop="toggleAll">
                        <img v-if="!props.all" :src="hicon1" height="32" @click.stop="toggleAll">
                      </td>
                      <td
                        v-for="header in props.headers"
                        :key="header.text"
                        :width="header.width"
                        :class="['column sortable', pageSync.descending ? 'desc' : 'asc', header.value === pageSync.sortBy ? 'active' : '', 'xs-text-' + header.align]"
                        @click="changeSort(header)"
                      >
                        <v-layout row :class="'xs-text-' + header.align" style="text-wrap: none;">
                          <v-icon small v-if="header.sortable && pageSync.descending && pageSync.sortBy === header.value">arrow_upward</v-icon>
                          <v-icon small v-if="header.sortable && !pageSync.descending && pageSync.sortBy === header.value">arrow_downward</v-icon>
                          <v-flex :style="'text-align: ' + header.align + ';'"><span>{{ header.text }}</span></v-flex>
                        </v-layout>
                      </td>
                    </tr>
                  </template>
                  <template v-slot:items="props">
                    <tr :active="props.selected"  v-if="!isMobile">
                      <td class="xs-text-center">
                        <img v-if="props.selected" :src="hicon2" height="32" @click="props.selected = !props.selected">
                        <img v-if="!props.selected" :src="hicon1" height="32" @click="props.selected = !props.selected">
                      </td>
                      <td @click="openItem(props.item)" class="text-xs-left pa-2" v-for="(head, hi) in headers" valign="top" v-bind:key="hi">
                        <!--<img v-if="head.type === 'preview'" :src="props.item.thumbScaled" height="128">-->
                        <div v-if="head.type === 'preview'" :style="getPreviewStyle(props.item)">
                          <img v-if="head.type === 'preview'" :src="props.item.thumbScaled" width="300" style="margin-top: -10px;">
                        </div>
                        <div v-if="head.type === 'name'">
                          <span class="cTitle">{{ getCategories(props.item.categories) }}</span>
                          <span v-if="getCategories(props.item.categories)">vom</span>
                          <span>{{ getDate(props.item.time) }}</span><br>
                          <span v-for="(category, i) in props.item.categories" v-bind:key="i"><span v-if="catObjectsByGuid[category]"
                                                                                                    v-for="field in catObjectsByGuid[category].extraFields" class="pr-1"
                                                                                                    v-bind:key="field.id"><span class="pr-1">{{field.name}}</span><span class="pr-1">{{getFieldValue(props.item, catObjectsByGuid[category], field)}} </span><span v-if="field.labelValue">{{field.labelValue}}</span></span></span>
                          <br>
                          <!--Invoice 2020-3464.pdf -->
                          &nbsp;
                          <span v-if="props.item.status" v-for="(guidStatus, ii) in props.item.status" v-bind:key="hi + '' + ii">
                          <span class="pr-1" v-if="catStatusByGuid[guidStatus]">Status:
                            <span  :style="getStatusStyle(catStatusByGuid[guidStatus])">
                              <span style="font-weight: bolder">
                            {{catStatusByGuid[guidStatus].title}}</span>
                            </span>
                          </span>
                        </span>
                          <br>
                          <span class="name">Name:{{ props.item.name }}</span>
                          <!--
                          (<span class="size pl-1">{{ toMB(props.item.size) }}</span>)
                          -->
                        </div>
                        <div v-if="head.type === 'category'">
                          {{ getCategories(props.item.categories) }}
                        </div>
                        <div v-if="head.type === 'extraFields'">
                          <span class="pr-1">{{getFieldValue(props.item, head.category, head.field)}}</span>
                          {{head.field.labelValue}}
                        </div>
                        <div v-if="head.type === 'date'" class="text-center">
                          <span>{{ getDate(props.item.time) }}</span>
                        </div>
                      </td>
                    </tr>
                    <tr v-else> <!-- isMobile -->
                      <td>
                        <ul class="flex-content">
                          <li @click="openItem(props.item)" class="text-xs-left pa-2" v-for="(head, hi) in headers" valign="top" v-bind:key="hi">
                            <!--<img v-if="head.type === 'preview'" :src="props.item.thumbScaled" height="128">-->
                            <center>
                              <div v-if="head.type === 'preview'" :style="getPreviewStyleMobile(props.item)">
                                <img v-if="head.type === 'preview'" :src="props.item.thumbScaled" width="300" style="margin-top: -10px;">
                              </div>
                            </center>

                            <div v-if="head.type === 'name'">
                              <li data-label="Name" class="liMobile">
                                <div class="nameMobile">{{ props.item.name }}</div>
                                (<div class="size pl-1">{{ toMB(props.item.size) }}</div>)
                              </li>
                              <li data-label="Kategorie">
                                <span class="cTitle">{{ getCategories(props.item.categories) }}</span>
                              </li>

                              <li data-label="vom">
                                <span>{{ getDate(props.item.time) }}</span><br>
                              </li>
                              <div v-for="(category, i) in props.item.categories" v-bind:key="i">
                                <div v-if="catObjectsByGuid[category]" v-for="field in catObjectsByGuid[category].extraFields" class="pr-1" v-bind:key="field.id">
                                  <span class="pr-1">{{field.name}}</span>
                                  <span class="pr-1">{{getFieldValue(props.item, catObjectsByGuid[category], field)}} </span>
                                  <span v-if="field.labelValue">{{field.labelValue}}</span>
                                </div>
                              </div>
                              <br>
                              <!--Invoice 2020-3464.pdf -->
                              <div v-if="props.item.status" v-for="(guidStatus, ii) in props.item.status"
                                    v-bind:key="hi + '' + ii">
                                <span class="pr-1" v-if="catStatusByGuid[guidStatus]">Status:
                                  <span :style="getStatusStyle(catStatusByGuid[guidStatus])">
                                    <span style="font-weight: bolder">
                                  {{catStatusByGuid[guidStatus].title}}</span>
                                  </span>
                                </span>
                              </div>
                            <br>
                            </div>
                            <div v-if="head.type === 'category'">
                              {{ getCategories(props.item.categories) }}
                            </div>
                            <div v-if="head.type === 'extraFields'">
                              <span class="pr-1">{{getFieldValue(props.item, head.category, head.field)}}</span>
                              {{head.field.labelValue}}
                            </div>
                            <div v-if="head.type === 'date'" class="text-center">
                              <span>{{ getDate(props.item.time) }}</span>
                            </div>
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card>
        </v-tab-item>
        <v-tab-item
          key="Tab2"
        >
          <v-card
            flat
            class="pa-3"
          >
            <v-layout row wrap justify-start style="background-color: white;" class="pa-4">
              <v-flex xs12 v-if="missingLizenz">
                <v-card>
                <v-card-text class="missingLizenz pa-3 subheading">
                  <v-icon color="orange">warning</v-icon>
                  In der Demo Version können nur bis zu 3 Monate in der Auswertung angezeigt werden.
                  <v-icon color="orange">warning</v-icon>
                </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 class="mb-4">
                <v-layout row wrap v-if="selectedCategories">
                  <v-flex xs12 sm6 v-for="(category, i) in selectedCategories" v-bind:key="i" v-if="category.extraFields && category.extraFields.length > 0">
                    <v-card flat>
                      <v-flex xs12 class="pa-2 pl-3 text-xs-left">
                        <v-card-text class="headline pl-0">Kategorie {{category.title}}</v-card-text>
                      </v-flex>
                      <v-flex xs12 v-if="category.extraFields" v-for="field in category.extraFields"
                              class="pa-2 pl-3 text-xs-left" v-bind:key="field.id">
                        Summe: <span>{{field.name}}</span> <span>{{getSumFormated(category.internal_id + '_' + field.key)}}</span><br>
                      </v-flex>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 class="mb-4">
              <v-layout row wrap v-if="!selectedCategories">
                    <v-flex xs12 sm6 v-for="(category, i) in categories" v-bind:key="i" v-if="category.extraFields && category.extraFields.length > 0">
                      <v-card flat>
                          <v-flex xs12 class="pa-2 pl-3 text-xs-left">
                            <v-card-text class="headline pl-0">Kategorie {{category.title}}</v-card-text>
                          </v-flex>
                          <v-flex xs12 v-if="category.extraFields" v-for="field in category.extraFields"
                                  class="pa-2 pl-3 text-xs-left" v-bind:key="field.id">
                            Summe: <span>{{field.name}}</span> <span>{{getSumFormated(category.internal_id + '_' + field.key)}}</span><br>
                          </v-flex>
                      </v-card>
                    </v-flex>
              </v-layout>
              </v-flex>
              <v-layout class="justify-space-around mt-4" row wrap>
                <v-flex xs12>
                  <v-card flat>
                    <v-card-text>
                      <span class="headline text-xs-left text-sm-center">Balkendiagramme Auswertung</span><br>
                      <span>Ausgewertet wurden {{pageSync.totalItems}} von {{totalItems}} Einträgen</span>
                    </v-card-text>
                    <v-btn outline color="#6f6f6f" class="title text-none" @click="loadAll()" v-if="pageSync.totalItems !== totalItems">Jetzt alle Einträge auswerten</v-btn>
                  </v-card>
                </v-flex>
                <v-flex xs12 md6 class="pa-3">
                  <v-card min-width="320px" class="pa-4" flat>
                    <v-card-text class="title">Auswertung Summe</v-card-text>
                      <HBarChart ref="myChart2" :chartData="chartData" :options="barChartOptions"></HBarChart>
                  </v-card>
                </v-flex>
                  <v-flex xs12 md6 class="pa-3">
                  <v-card min-width="320px" class="pa-4" flat>
                    <v-card-text class="title">Auswertung Verlauf</v-card-text>
                      <LineChart ref="lineChart1" :chartData="lineChartData" :options="lineChartOptions" ></LineChart>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-card>
        </v-tab-item>
      </v-tabs>
      <FileDialog ref="fileDialog" @onSave="onSaveItem"></FileDialog>
    </v-container>
    <main-footer></main-footer>
  </v-container>
</template>

<script>
import MainToolbar from './../toolbar/MainToolbar'
import Vue from 'vue'
import FileDialog from './dialogs/FileDialog.vue'
// import sas from 'surfandscan'
import HBarChart from '../widgets/charts/BarChart'
import LineChart from '../widgets/charts/LineChart'
import DialogWorkOnFiles from '../dialogs/DialogWorkOnFiles'
import moment from 'moment'
import DialogStatus from '../dialogs/DialogStatus'
import MainFooter from '../footer/MainFooter'

export default {
  components: {MainFooter, DialogStatus, DialogWorkOnFiles, HBarChart, FileDialog, MainToolbar, LineChart},
  name: 'pgSearch',
  data () {
    return {
      sums: {},
      panel: 0,
      monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
      chartData: {},
      on1: {},
      totalItems: -1,
      on2: {},
      tableKey: 0,
      modal: false,
      isLoading: false,
      dateFrom: '',
      active: 'Tab1',
      dateFromObj: new Date(),
      dateFromPS: '',
      dateTo: '',
      dateToObj: null,
      dateToPS: null,
      menu1: false,
      menu11: false,
      lineChartOptions: {
        legend: {
          display: true
        },
        bezierCurve: false,
        responsive: true,
        elements: {
          line: {
            tension: 0
          }
        },
        tooltips: {
          enabled: true,
          callbacks: {
            title: function (tooltipItem, data) {
              // return data[datasets][tooltipItem[0][dataSetIndex]].label
              return data['labels'][tooltipItem[0]['index']]
            },
            label: function (tooltipItem, data) {
              let v = data['datasets'][tooltipItem.datasetIndex]['data'][tooltipItem['index']]
              v = Vue.prototype.$storage.formatStringToCurrency(v)
              return v + ' ' + Vue.prototype.$storage.currencySymbol
            },
            afterLabel: function (tooltipItem, data) {
              // var dataset = data['datasets'][0];
              return ''
            }
          }
        },
        scales: {
          xAxes: [{
            ticks: {
              scaleShowLabels: true
            }
          }],
          yAxes: [{
            ticks: {
              scaleShowLabels: true,
              callback: function (value, index, values) {
                var val = Vue.prototype.$storage.formatStringToCurrency(value)
                return val + ' ' + Vue.prototype.$storage.currencySymbol
              }
            }
          }]
        }
      },
      barChartOptions: {
        responsive: true,
        tooltips: {
          enabled: true,
          callbacks: {
            title: function (tooltipItem, data) {
              return data['labels'][tooltipItem[0]['index']]
            },
            label: function (tooltipItem, data) {
              let v = data['datasets'][tooltipItem.datasetIndex]['data'][tooltipItem['index']]
              v = Vue.prototype.$storage.formatStringToCurrency(v)
              return v + ' ' + Vue.prototype.$storage.currencySymbol
            },
            afterLabel: function (tooltipItem, data) {
              // var dataset = data['datasets'][0];
              return ''
            }
          }
        },
        scales: {
          xAxes: [{
            ticks: {
              scaleShowLabels: true
            }
          }],
          yAxes: [{
            ticks: {
              scaleShowLabels: true,
              callback: function (value, index, values) {
                var val = Vue.prototype.$storage.formatStringToCurrency(value)
                return val + ' ' + Vue.prototype.$storage.currencySymbol
              }
            }
          }]
        }
      },
      pageSync: {
        descending: true,
        rowsPerPage: 25,
        sortBy: 'created'
      },
      myMenu: false,
      menu2: false,
      menu22: false,
      date: new Date(),
      currentItem: null,
      dialog: false,
      categories: [],
      computedSearch: true,
      catNames: [],
      catObjectsByGuid: [],
      catStatusByGuid: [],
      statusList: [],
      currentStatus: null,
      selectedCategories: null,
      lineChartData: {
        labels: [],
        datasets: [
          {
            label: 'Verlauf',
            backgroundColor: '#39d2f8',
            fill: false,
            data: []
          }
        ]
      },
      headers: [
        {
          text: 'Vorschau',
          align: 'center',
          class: 'text-xs-center',
          value: 'preview',
          type: 'preview',
          width: 80,
          sortable: false
        },
        {
          text: 'Name',
          align: 'left',
          class: 'text-xs-left',
          sortable: false,
          value: 'name',
          type: 'name'
        },
        {
          text: 'Kategorien',
          class: 'text-xs-center',
          value: 'categories',
          type: 'category',
          width: 280,
          sortable: false
        },
        {
          text: 'Datum',
          value: 'time',
          class: 'text-xs-center',
          align: 'center',
          type: 'date',
          width: 100,
          sortable: false
        }
      ],
      hicon1: './static/check_box_outline_blank.png', // head Icon
      hicon2: './static/check_box.png', // head Icon
      searchResult: [],
      missingLizenz: false,
      search: '',
      myMenuFilter: false,
      myMenuFilter1: false,
      on: false,
      showFilter: false,
      showAddSection: false,
      selected: [],
      dateFilter: 'lastCreated',
      dateFilters: [{
        text: 'zuletzt hinzugefügt',
        value: 'lastCreated'
      },
      {
        text: 'Aktuelles Jahr',
        value: 'currentYear'
      },
      {
        text: 'Letztes Jahr',
        value: 'lastYear'
      },
      {
        text: 'Aktueller Monat',
        value: 'currentMonth'
      },
      {
        text: 'Letzter Monat',
        value: 'lastMonth'
      },
      {
        text: 'Letzten 6 Monate',
        value: 'last6Month'
      }],
      isMobile: false
    }
  },
  watch: {
    pageSync: {
      handler () {
        this.doSearch()
        /*
        this.getDataFromApi()
          .then(data => {
            this.desserts = data.items
            this.totalDesserts = data.total
          })
         */
      },
      deep: true
    }
  },
  methods: {
    doAdd () {
      this.$eventHub.$emit('OnManuellUpload', false)
    },
    loadAll () {
      this.pageSync.rowsPerPage = -1
      this.doSearch()
    },
    changeDateFilter (f) {
      var d = new Date()
      console.log('changeDateFilter', f)
      if (f.value === 'lastCreated') {
        this.doClearFROM()
        this.doClearTO()
        this.myMenuFilter = false
        return
      } else if (f.value === 'currentMonth') {
        d.setMinutes(59)
        d.setHours(23)
        d.setSeconds(59)
        d.setMonth(d.getMonth() + 1)
        d.setDate(0)
        this.dateToObj = d
        // var lastDayOfMonth = new Date(d.getFullYear(), d.getMonth()+1, 0)
        let md = moment(d)
        this.dateToPS = md.format('YYYY-MM-DD')
        this.dateTo = this.dateToObj.toLocaleDateString('de-DE')
        d = new Date(d.getTime())

        d.setMinutes(0)
        d.setDate(1)
        d.setMonth(d.getMonth())
        d.setHours(0)
        d.setSeconds(0)
        this.dateFromObj = d
        md = moment(d)
        this.dateFromPS = md.format('YYYY-MM-DD')
        this.dateFrom = d.toLocaleDateString('de-DE')
      } else if (f.value === 'currentYear') {
        d.setMinutes(59)
        d.setHours(23)
        d.setSeconds(59)
        d.setMonth(12)
        d.setDate(0)
        this.dateToObj = d
        // var lastDayOfMonth = new Date(d.getFullYear(), d.getMonth()+1, 0)
        let md = moment(d)
        this.dateToPS = md.format('YYYY-MM-DD')
        this.dateTo = this.dateToObj.toLocaleDateString('de-DE')
        d = new Date(d.getTime())
        d.setMinutes(0)
        d.setDate(1)
        d.setMonth(0)
        d.setHours(0)
        d.setSeconds(0)
        this.dateFromObj = d
        md = moment(d)
        this.dateFromPS = md.format('YYYY-MM-DD')
        this.dateFrom = d.toLocaleDateString('de-DE')
      } else if (f.value === 'lastYear') {
        d.setMinutes(59)
        d.setHours(23)
        d.setSeconds(59)
        d.setMonth(12)
        d.setFullYear(d.getFullYear() - 1)
        d.setDate(0)
        this.dateToObj = d
        // var lastDayOfMonth = new Date(d.getFullYear(), d.getMonth() + 1, 0)
        let md = moment(d)
        this.dateToPS = md.format('YYYY-MM-DD')
        this.dateTo = this.dateToObj.toLocaleDateString('de-DE')
        d = new Date(d.getTime())
        d.setMinutes(0)
        d.setDate(1)
        d.setMonth(0)
        d.setHours(0)
        d.setSeconds(0)
        d.setFullYear(d.getFullYear())
        this.dateFromObj = d
        md = moment(d)
        this.dateFromPS = md.format('YYYY-MM-DD')
        this.dateFrom = d.toLocaleDateString('de-DE')
      } else if (f.value === 'last6Month') {
        d.setMinutes(59)
        d.setHours(23)
        d.setSeconds(59)
        d.setMonth(d.getMonth() + 1)
        d.setDate(0)
        this.dateToObj = d
        // var lastDayOfMonth = new Date(d.getFullYear(), d.getMonth()+1, 0)
        let md = moment(d)
        this.dateToPS = md.format('YYYY-MM-DD')
        this.dateTo = this.dateToObj.toLocaleDateString('de-DE')
        d = new Date(d.getTime())
        d.setMinutes(0)
        d.setDate(1)
        d.setMonth(d.getMonth() - 6)
        d.setHours(0)
        d.setSeconds(0)
        this.dateFromObj = d
        md = moment(d)
        this.dateFromPS = md.format('YYYY-MM-DD')
        this.dateFrom = d.toLocaleDateString('de-DE')
      } else if (f.value === 'lastMonth') {
        d.setMinutes(59)
        d.setHours(23)
        d.setSeconds(59)
        d.setMonth(d.getMonth())
        d.setDate(0)
        this.dateToObj = d
        // var lastDayOfMonth = new Date(d.getFullYear(), d.getMonth()+1, 0)
        let md = moment(d)
        this.dateToPS = md.format('YYYY-MM-DD')
        this.dateTo = this.dateToObj.toLocaleDateString('de-DE')
        d = new Date(d.getTime())
        d.setMinutes(0)
        d.setDate(1)
        d.setMonth(d.getMonth())
        d.setHours(0)
        d.setSeconds(0)
        this.dateFromObj = d
        md = moment(d)
        this.dateFromPS = md.format('YYYY-MM-DD')
        this.dateFrom = d.toLocaleDateString('de-DE')
      }
      this.doSearch()
    },
    onResize () {
      if (window.innerWidth < 769) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    startUpload () {
      this.myMenu = false
      this.dialog = true
    },
    startScan () {
      console.log('startScan')
      Vue.prototype.scanApi.setCurrentJob(null)
      this.$router.push('page4')
    },
    toggleAll () {
      console.log('toggleAll', this.selected)
      if (this.selected.length) {
        this.selected = []
      } else {
        this.selected = this.searchResult.slice()
      }
    },
    changeSort (header) {
      if (!header.sortable) return
      let column = header.value
      if (this.pageSync.sortBy === column) {
        this.pageSync.descending = !this.pageSync.descending
      } else {
        this.pageSync.sortBy = column
        this.pageSync.descending = false
      }
    },
    toMB: function (bytes, decimals) {
      if (bytes === 0) return '0 Bytes'
      var k = 1024
      var dm = decimals <= 0 ? 0 : decimals || 2
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      var i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
    getFieldValue: function (item, category, field) {
      item = Vue.prototype.$storage.checkExtraFieldStatus(item)
      let key = category.internal_id + '_' + field.key
      return item.extraFields[key]
    },
    onChangeCategory: function (categories) {
      console.log('categories', categories)
      this.updateHeaders(categories)
      this.doSearch()
    },
    onChangeStatus: function (status) {
      console.log('status', status)
      this.doSearch()
    },
    updateTab: function (tab) {
      console.log('tab', tab)
      if (tab === 1) {
        console.log('tab', this.$refs)
        this.$refs['myChart2'].updateRendering()
        this.$refs['lineChart1'].updateRendering()
      }
    },
    updateHeaders: function (categories) {
      var heads = []
      if (!categories || categories.length > 1) {
        heads = [
          {
            text: 'Vorschau',
            align: 'left',
            value: 'name',
            type: 'preview',
            sortable: false
          },
          {
            text: 'Name',
            align: 'left',
            sortable: true,
            value: 'name',
            type: 'name'
          },
          {text: 'Kategorien', value: 'categories', type: 'category'},
          {text: 'Datum', value: 'time', align: 'center', type: 'date'}
        ]
      } else {
        let category = categories[0]
        heads.push({
          text: 'Vorschau',
          align: 'left',
          value: 'name',
          type: 'preview'
        })
        heads.push({
          text: 'Name',
          align: 'left',
          sortable: true,
          value: 'name',
          type: 'name'
        })
        if (category.extraFields) {
          for (var i in category.extraFields) {
            let field = category.extraFields[i]
            let headItem = {
              text: field.name,
              align: 'left',
              sortable: true,
              category: category,
              type: 'extraFields',
              field: field,
              value: category.internal_id + '_' + field.key
            }
            heads.push(headItem)
          }
        }
        heads.push({text: 'Datum', value: 'time', align: 'center', type: 'date'})
      }
      this.headers = heads
    },
    openItem: function (item) {
      this.currentItem = item
      this.currentItem.tableIndex = this.searchResult.indexOf(item)
      this.$refs.fileDialog.open(this.currentItem)
    },
    getStatusStyle: function (status) {
      var css = ''
      css += 'color:' + status.config.color + ';'
      css += 'font-weight:bold;'
      return css
    },
    onSaveItem: function (res) {
      this.searchResult[this.currentItem.tableIndex] = res.item
      this.tableKey++
      this.$eventHub.$emit('OnShowIdle', false)
    },
    doClearTO: function (d) {
      this.dateToObj = null
      this.dateToPS = ''
      this.dateTo = ''
      this.doSearch()
    },
    doClearFROM: function (d) {
      this.dateFromObj = null
      this.dateFromPS = ''
      this.dateFrom = ''
      this.doSearch()
    },
    onClick: function () {
      window.history.back()
    },
    singlePage: function () {
      Vue.prototype.$eventHub.$emit('setConfiguration', {
        name: 'duplex',
        value: false
      })
      Vue.prototype.scanApi.setCurrentJob(null)
      this.$router.push('page3')
    },
    /**
     * @param item
     * @returns {string}
     */
    getPreviewStyle: function (item) {
      let style = 'overflow: hidden; width: 300px; height:156px;'
      return style
    },
    getPreviewStyleMobile: function (item) {
      let style = 'overflow: hidden; width: 320px; height:156px;'
      return style
    },
    getCategories: function (arrayOfGuids) {
      var items = []
      for (var i in arrayOfGuids) {
        items.push(this.catNames[arrayOfGuids[i]])
      }
      return items.join(', ')
    },
    getDateTime: function (str) {
      return new Date(str).toLocaleDateString('de-DE') + ' ' + new Date(str).toLocaleTimeString('de-DE')
    },
    getDate: function (str) {
      return new Date(str).toLocaleDateString('de-DE')
    },
    onGetSearchResult: function (data) {
      let showLineChart = false
      let showBarChart = true
      let lineChartType = 'daily'
      let lineChartIncrement = 1
      let minMonth = 11
      let maxMonth = 0
      this.totalItems = data.totalItems
      this.missingLizenz = false
      let from = this.dateFromObj
      let to = this.dateToObj
      if (!(this.dateFromObj && this.dateToObj)) {
        if (data != null) {
          if (data.files != null) {
            from = 9999999999999999
            to = 0
            for (let i in data.files) {
              let item = data.files[i]
              let t = item.time
              console.log('t1', t, from, to)
              from = Math.min(from, t)
              to = Math.max(to, t)
              console.log('t2', t, from, to)
            }
          }
          from = new Date(from)
          to = new Date(to)
        }
      }
      minMonth = from.getMonth() + 1
      maxMonth = to.getMonth() + 1
      console.log('fromto', from, to, minMonth, maxMonth)
      if (from && to) {
        showLineChart = true
        let cntMonths = this.monthDiff(from, to)
        if (cntMonths <= 1) {
          lineChartIncrement = this.daysInMonth(from.getMonth(), from.getYear())
          lineChartType = 'daily'
        } else {
          lineChartIncrement = cntMonths + 1
          lineChartType = 'monthly'
          if (!Vue.prototype.$sasConfig.licenseValid) {
            if (cntMonths > 3) {
              this.missingLizenz = true
            }
          }
        }
      }
      if (this.missingLizenz) {
        showLineChart = false
        showBarChart = false
      }

      this.searchResult = []
      this.sums = {}
      let sumPerDay = {}
      let sumPerMonth = {}
      let cmp = this
      this.chartData = {}
      this.pageSync.totalItems = data.files.length
      if (data != null) {
        if (data.files != null) {
          for (let i in data.files) {
            let item = data.files[i]
            item.selected = false
            Vue.prototype.$storage.checkExtraFieldStatus(item)
            for (const [key, value] of Object.entries(item.extraFields)) {
              item[key] = value
              if (!this.sums[key]) {
                this.sums[key] = 0
              }
              let v = this.getFloatOfString(value)
              this.sums[key] += v
              let keyForSum = key.split('_')[0]
              let sumpdKey = keyForSum + '' + new Date(item.time).getDay()
              if (sumPerDay[sumpdKey]) {
                sumPerDay[sumpdKey] += v
              } else {
                sumPerDay[sumpdKey] = v
              }

              sumpdKey = keyForSum + '' + new Date(item.time).getMonth()
              minMonth = Math.min(minMonth, new Date(item.time).getMonth())
              maxMonth = Math.max(maxMonth, new Date(item.time).getMonth())
              if (sumPerMonth[sumpdKey]) {
                sumPerMonth[sumpdKey] += v
              } else {
                sumPerMonth[sumpdKey] = v
              }
            }
          }
          this.searchResult = data.files
        }
      }

      let cd = {
        labels: [],
        datasets: []
      }
      let colors = [
        '#dc2020',
        '#e06636',
        '#e09436',
        '#e2b735',
        '#e2df35',
        '#a0e235',
        '#61e232',
        '#31e05d',
        '#2fe28d',
        '#2fe2d3',
        '#2fafe2',
        '#277ae0'
      ]
      cd.labels.push('Summe')
      let cats = this.categories
      if (this.selectedCategories && this.selectedCategories.length > 0) {
        cats = this.selectedCategories
      }
      if (showBarChart) {
        for (var i in cats) {
          let cat = cats[i]
          for (var ii in cat.extraFields) {
            let field = cat.extraFields[ii]
            let key = cat.internal_id + '_' + field.key
            let dSums = cmp.sums[key]
            cd.datasets.push({
              label: cat.title + ' ' + field.name,
              backgroundColor: colors[i],
              fill: true,
              data: [dSums]
            })
          }

          this.chartData = cd
        }
      }
      //
      this.lineChartData = {
        labels: [],
        datasets: []
      }
      if (lineChartType === 'daily') {
        this.lineChartData.labels.push('Tagesverlauf')
      } else {
        this.lineChartData.labels.push('Monatsverlauf')
      }
      if (showLineChart) {
        for (let i = 0; i < lineChartIncrement; i++) {
          if (lineChartType === 'daily') {
            this.lineChartData.labels.push('' + (i + 1))
          } else if (lineChartType === 'monthly') {
            this.lineChartData.labels.push('' + this.monthNames[(i + minMonth) % 12])
          }
        }

        let lineTickSum = 0
        for (var iCat in cats) {
          let cat = cats[iCat]
          let hasExtraFields = cat.extraFields && cat.extraFields.length > 0
          if (!hasExtraFields) {
            continue
          }
          let dataSet = {
            label: cat.title,
            backgroundColor: colors[iCat],
            fill: true,
            data: []
          }
          for (let i = 0; i < lineChartIncrement; i++) {
            let vsp
            if (lineChartType === 'daily') {
              let keyForSum = cat.internal_id + '' + (i + 1)
              vsp = sumPerDay[keyForSum]
            } else if (lineChartType === 'monthly') {
              let keyForSum = cat.internal_id + '' + (i + minMonth)
              vsp = sumPerMonth[keyForSum]
            }
            if (vsp !== undefined) {
              lineTickSum += vsp
            }
            dataSet.data.push(lineTickSum)
          }
          this.lineChartData.datasets.push(dataSet)
        }
      }
      this.isLoading = false
      this.computedSearch = false
      cmp.$eventHub.$emit('OnShowIdle', false)
    },
    monthDiff: function (d1, d2) {
      var months
      months = (d2.getFullYear() - d1.getFullYear()) * 12
      months -= d1.getMonth()
      months += d2.getMonth()
      return months <= 0 ? 0 : months
    },
    daysInMonth: function (month, year) {
      return new Date(year, month, 0).getDate()
    },
    getFloatOfString: function (str) {
      if (!str) return 0
      str = str.replace(/\./g, '')
      str = str.replace(/,/g, '.')
      return ('0' + str) * 1
    },
    removeStatus: function (item) {
      console.log('removeStatus', item)
      var index = this.currentStatus.indexOf(item)
      if (index > -1) {
        this.currentStatus.splice(index, 1)
      }
      this.doSearch()
    },
    removeCategory: function (item) {
      console.log('removeCategory', item)
      var index = this.selectedCategories.indexOf(item)
      if (index > -1) {
        this.selectedCategories.splice(index, 1)
      }
      this.doSearch()
    },
    getSumFormated: function (key) {
      let s = this.sums[key]
      if (!s) s = 0
      let fmt = Vue.prototype.$storage.formatStringToCurrency(s)
      fmt = fmt + ' ' + Vue.prototype.$storage.currencySymbol
      return fmt
    },
    doSearch: function () {
      let cmp = this
      this.myMenuFilter = false
      this.isLoading = true
      cmp.$eventHub.$emit('OnShowIdle', true)
      var cats = []
      var stats = []
      if (cmp.selectedCategories) {
        for (var i in cmp.selectedCategories) {
          cats.push(cmp.selectedCategories[i].guid)
        }
      }
      if (cmp.currentStatus) {
        for (var ii in cmp.currentStatus) {
          stats.push(cmp.currentStatus[ii].guid)
        }
      }
      var reqData = {
        keyWord: cmp.search,
        categories: cats.join(),
        status: stats.join(),
        page: cmp.pageSync.page - 1,
        limit: cmp.pageSync.rowsPerPage
      }
      if (cmp.dateTo !== null && (cmp.dateTo.length > 0)) {
        reqData.dateTo = cmp.dateToObj.getTime()
      }
      if (cmp.dateFrom !== null && (cmp.dateFrom.length > 0)) {
        reqData.dateFrom = cmp.dateFromObj.getTime()
      }
      cmp.$nextTick(function () {
        cmp.active = 'Tab1'
        cmp.$refs.tab1.click()
        Vue.prototype.$dms.searchStorage(reqData, cmp.onGetSearchResult, Vue.prototype.$api.onError)
      })
    },
    multiPage: function () {
      Vue.prototype.$eventHub.$emit('setConfiguration', {
        name: 'duplex',
        value: true
      })
      Vue.prototype.scanApi.setCurrentJob(null)
      this.$router.push('page3')
    },
    onChangeTo (date) {
      console.log('onChangeTo', date)
      const [year, month, day] = date.split('-')
      var d = new Date()
      d.setFullYear(year)
      d.setMonth(month - 1)
      d.setDate(day)
      d.setMinutes(59)
      d.setHours(23)
      d.setSeconds(59)
      console.log('onChangeTo', d, day)
      this.dateToObj = d
      let md = moment(d)
      this.dateToPS = md.format('YYYY-MM-DD')
      this.dateTo = this.dateToObj.toLocaleDateString('de-DE')
      this.doSearch()
    },
    onChangeFrom (date) {
      console.log('onChangeFrom', date)
      const [year, month, day] = date.split('-')
      var d = new Date()
      d.setFullYear(year)
      d.setMonth(month - 1)
      d.setDate(day)
      d.setMinutes(0)
      d.setHours(0)
      d.setSeconds(0)
      console.log('onChangeFrom', d, day)
      this.dateFromObj = d
      let md = moment(d)
      this.dateFromPS = md.format('YYYY-MM-DD')
      this.dateFrom = d.toLocaleDateString('de-DE')
      this.doSearch()
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${day.padStart(2, '0')}.${month.padStart(2, '0')}.${year}`
    },
    reloadConfig: function () {
      this.scanParameter = Vue.prototype.scanApi.getScanParameter()
      this.categories = Vue.prototype.$storage.getCategories()
      this.catNames = Vue.prototype.$storage.getCategoriesNamesList()
      this.catObjectsByGuid = Vue.prototype.$storage.getCategoriesObjectGuidList()
      this.catStatusByGuid = Vue.prototype.$storage.getStatusObjectGuidList()
      this.statusList = Vue.prototype.$storage.getStatusList()
      console.log('reloadConfig', this.statusList)
    },
    doWorkOnFiles: function (item) {
      console.log('doWorkOnFiles', item)
      let guids = []
      for (var i = 0; i < item.files.length; i++) {
        let file = item.files[i]
        guids.push(file.guid)
      }
      if (item.type === 'delete') {
        this.$eventHub.$emit('OnShowIdle', true)
        Vue.prototype.$dms.deleteFilesFromStorage(guids, this.onWorkOnFilesDone)
      } else if (item.type === 'status') {
        let dataObject = {
          status: item.status.guid
        }
        this.$eventHub.$emit('OnShowIdle', true)
        Vue.prototype.$dms.updateStorageItemsStatus(guids, dataObject, this.onWorkOnFilesDone)
      } else if (item.type === 'category') {
        let catGuids = []
        for (var c = 0; c < item.categories.length; c++) {
          let cat = item.categories[c]
          catGuids.push(cat.guid)
        }
        let dataObject = {
          categories: catGuids.join()
        }
        this.$eventHub.$emit('OnShowIdle', true)
        Vue.prototype.$dms.updateStorageItemsCategories(guids, dataObject, this.onWorkOnFilesDone)
      } else if (item.type === 'mail') {
        let dataObject = {
          mail_to: item.mail_to,
          mail_to_name: item.mail_to_name,
          mail_subject: item.mail_subject,
          mail_body: item.mail_body,
          mail_salut: item.mail_salut,
          mail_regards: item.mail_regards,
          mail_from_name: item.mail_from_name
        }
        this.$eventHub.$emit('OnShowIdle', true)
        Vue.prototype.$dms.mailSendStorageItems(guids, dataObject, this.onWorkOnFilesDone)
      }
    },
    onWorkOnFilesDone: function (result) {
      console.log('onWorkOnFilesDone', result)
      this.$eventHub.$emit('OnShowIdle', false)
      this.$refs.dlgStatus.open(result)
      this.doSearch()
    },
    workOnFiles: function (files, type) {
      this.$refs.dlgWorkOnFiles.open({
        title: 'Dokumente verwalten',
        files: files,
        type: type
      })
      console.log('workOnFiles', files, type)
    }
  },
  created () {
    Vue.prototype.$eventHub.$on('filespoolchanged', this.doSearch)
    Vue.prototype.$eventHub.$on('reloadConfig', this.reloadConfig)
  },
  destroyed () {
    Vue.prototype.$eventHub.$off('filespoolchanged', this.doSearch)
    Vue.prototype.$eventHub.$off('reloadConfig', this.reloadConfig)
  },
  mounted () {
    this.reloadConfig()
    this.fileName = this.scanParameter.fileNamePattern
    this.computedSearch = true
    if (this.$route.params && this.$route.params.searchtext) {
      this.search = this.$route.params.searchtext
    }
    var d = new Date()
    // d.setDate(1)
    d.setMinutes(59)
    d.setHours(23)
    d.setSeconds(59)
    this.dateToObj = d
    let md = moment(d)
    this.dateToPS = md.format('YYYY-MM-DD')
    this.dateTo = this.dateToObj.toLocaleDateString('de-DE')

    this.changeDateFilter('lastCreated')
    /*
    d = new Date()
    d.setMinutes(0)
    d.setDate(1)
    d.setHours(0)
    d.setSeconds(0)
    this.dateFromObj = d
    md = moment(d)
    this.dateFromPS = md.format('YYYY-MM-DD')
    this.dateFrom = d.toLocaleDateString('de-DE')
    this.doSearch()

     */
  }
}
</script>

<style scoped>
  @media screen and (max-width: 768px) {
    .mobile table.v-table tr {
      max-width: 100%;
      position: relative;
      display: block;
    }
    .mobile table.v-table tr td {
      display: flex;
      width: 100%;
      border-bottom: 1px solid grey;
      height: auto;
      padding: 10px;
    }

    .mobile table.v-table tr td ul li:before {
      content: attr(data-label);
      padding-right: .5em;
      text-align: left;
      display: block;
      color: #999;
    }
    .v-datatable__actions__select
    {
      width: 50%;
      margin: 0px;
      justify-content: flex-start;
    }
    .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
      background: transparent;
    }
  }
  .mobile img{
    border: 1px solid lightgray;
  }
  .mobile li{
    margin-bottom: 5px;
  }
  .flex-content {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }

  .flex-item {
    padding: 5px;
    width: 50%;
    height: 40px;
    font-weight: bold;
  }
  .liMobile {
    display: flex;
  }
  .nameMobile {
    width: 170px;
    overflow:hidden;
    white-space:nowrap;
    text-overflow: ellipsis;
    color: #404040;
  }
  .myFixed {
    border: 0px;
    position: fixed;
    right: 23px;
    bottom: 63px;
    padding-top: 18px;
    margin-bottom: 0;
    z-index: 1000;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/PageSearch.vue